import { cx } from "@emotion/css";
import { classCombinerFromPrefix } from "@/app/pages/upik/resources/RenderIdentifier";
import { ContactUpikProps } from "@/app/pages/upik/resources/interfacesData";
import ContainerStyles from "@/app/pages/upik/styles/ContainerStyles.module.scss";
import React from "react";
import { contactUpikGermanCountries, contactUpikInternationalURL, contactUpikUSCountries } from "@/app/pages/upik/resources/constant";
import { contactUpikContent } from "@/app/pages/upik/resources/content";

const styles = ContainerStyles;
const classCombiner = classCombinerFromPrefix("850cb40c5e9711c2");

export const ContactUpik = (props: ContactUpikProps): JSX.Element => {
 const countriesNameArray = props.language === "de" ? contactUpikGermanCountries : contactUpikUSCountries;
    return (
        <>
            <div className={cx(classCombiner(styles, "upikContactUpikWrapper"))}>
                <div className="container spacing-pt-16 spacing-sm-pt-8">
                    <div className="row text-color-white">
                        <div className="col-md-12 px-4">
                            <h3 className="text-center spacing-mb-6 spacing-sm-mb-3">
                                {props.language === 'de' ? contactUpikContent.de.headingText : contactUpikContent.en.headingText}
                            </h3>
                        </div>
                        <div className="col-md-4 px-3">
                            <div className="bg-color-gray-background text-color-gray-primary">
                                <br></br><p>&nbsp;</p>
                                {countriesNameArray.columnFirst.map((country, index) => (
                                    <p key={index} className="text-center">
                                        <b>
                                            <a href={country.link} className={cx(classCombiner(styles, "upikCountriesName"))}>
                                                {country.name}
                                            </a>
                                        </b>
                                    </p>
                                ))}
                                <p>&nbsp;</p><p>&nbsp;</p><p className={cx(classCombiner(styles, "mb-2em"))}>&nbsp;</p>
                            </div>
                        </div>
                        <div className="col-md-4 px-3">
                            <div className="bg-color-gray-background text-color-gray-primary">
                                <br></br><p>&nbsp;</p>
                                {countriesNameArray.columnSecond.map((country, index) => (
                                    <p key={index} className="text-center">
                                        <b>
                                            <a href={country.link} className={cx(classCombiner(styles, "upikCountriesName"))}>
                                                {country.name}
                                            </a>
                                        </b>
                                    </p>
                                ))}
                                <p>&nbsp;</p><p>&nbsp;</p><p className={cx(classCombiner(styles, "mb-2em"))}>&nbsp;</p>
                            </div>
                        </div>
                        <div className="col-md-4 px-3">
                            <div className="bg-color-gray-background text-color-gray-primary">
                                <br></br><p>&nbsp;</p>
                                {countriesNameArray.columnThird.map((country, index) => (
                                    <p key={index} className="text-center">
                                        <b>
                                            <a href={country.link} className={cx(classCombiner(styles, "upikCountriesName"))}>
                                                {country.name}
                                            </a>
                                        </b>
                                    </p>
                                ))}
                                <p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p className="pb-2">&nbsp;</p><p className={cx(classCombiner(styles, "mb-2em"))}>&nbsp;</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={cx(classCombiner(styles, "upikContactUpikFooter"))}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 px-4">
                            <p className="text-end">
                                <a className={cx(classCombiner(styles, ""))} href={contactUpikInternationalURL}>
                                    <b>International</b>
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
